import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal } from "../../../../components";

class JobSeriesRestoreModal extends Component {
	constructor(props) {
		super(props);

		this.state = { restoreAll: false };
	}

	handleRadioChange = restoreAll => this.setState({ restoreAll });

	render() {
		const { lang } = global;
		const { restoreAll } = this.state;
		const { show, onConfirm, onCancel } = this.props;

		return (
			<Modal
				className="restore-recurring-job-modal"
				show={show}
				onExited={() => this.setState({ restoreAll: false })}
				onHide={() => onCancel()}
			>
				<Modal.Header>
					<Modal.Title>{lang.t("Restore Job")}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="row">
						<div className="col-sm-12">
							{lang.t("This job is part of a recurring series_")}{" "}
							{lang.t("Which instance would you like to restore_")}
						</div>
					</div>
					<div className="row">
						<div className="col-sm-12 radio">
							<label htmlFor="restoreAll_false">
								<input
									type="radio"
									name="restoreAll"
									id="restoreAll_false"
									onChange={() => this.handleRadioChange(false)}
									checked={!restoreAll}
								/>
								{lang.t("Only this job")}
							</label>
						</div>
						<div className="col-sm-12 radio">
							<label htmlFor="restoreAll_true">
								<input
									type="radio"
									name="restoreAll"
									id="restoreAll_true"
									onChange={() => this.handleRadioChange(true)}
									checked={restoreAll}
								/>
								{lang.t("All upcoming jobs in this series")}
							</label>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button
						type="button"
						className="btn btn-link"
						onClick={() => onCancel()}
					>
						{lang.t("Cancel")}
					</button>
					<button
						type="button"
						className="btn btn-primary"
						onClick={() => onConfirm(restoreAll)}
					>
						{lang.t("Continue")}
					</button>
				</Modal.Footer>
			</Modal>
		);
	}
}

JobSeriesRestoreModal.propTypes = {
	show: PropTypes.bool,
	onConfirm: PropTypes.func,
	onCancel: PropTypes.func,
};

JobSeriesRestoreModal.defaultProps = {
	show: false,
	onConfirm: () => {},
	onCancel: () => {},
};

export default JobSeriesRestoreModal;
